import React from 'react'


import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import { Box, Button, Card, Table, Typography } from '@mui/joy';

function VerantwortlicheView({ data }) {
  return (
    <>
      <Card
        variant="soft">
        <Table sx={{ '& thead th:nth-child(1)': { width: '35%' } }}>
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Rolle</th>
            </tr>
          </thead>
          <tbody>
            {data.Verantwortliche.map((item) => (
              <tr key={item.name}>
                <td>{item.name}</td>
                <td>{item.email}</td>
                <td>{item.bezeichnung}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>


    </>
  );
}

export default VerantwortlicheView
